// Smart INR number input helpers — accepts plain numbers, shortcuts like "60cr"/"5L",
// or comma-formatted numbers like "60,00,00,000" and returns a numeric value.

export const parseInrInput = (raw) => {
  if (raw == null) return NaN;
  let s = String(raw).trim().toLowerCase().replace(/[,\s₹]/g, '');
  if (s === '') return NaN;

  // Shortcut: "60cr" / "60 crore" → multiply by 1,00,00,000
  const crMatch = s.match(/^(\d+(?:\.\d+)?)(cr|crore|crores)$/);
  if (crMatch) return parseFloat(crMatch[1]) * 1e7;

  // Shortcut: "5L" / "5 lakh" → multiply by 1,00,000
  const lakhMatch = s.match(/^(\d+(?:\.\d+)?)(l|lac|lakh|lakhs)$/);
  if (lakhMatch) return parseFloat(lakhMatch[1]) * 1e5;

  // Shortcut: "5k" → multiply by 1,000
  const kMatch = s.match(/^(\d+(?:\.\d+)?)(k|thousand)$/);
  if (kMatch) return parseFloat(kMatch[1]) * 1e3;

  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
};

export const formatInrIndian = (n) => {
  if (!Number.isFinite(n) || n <= 0) return '';
  return n.toLocaleString('en-IN', { maximumFractionDigits: 0 });
};

export const formatInrFriendly = (n) => {
  if (!Number.isFinite(n) || n <= 0) return '';
  if (n >= 1e7) return `${(n / 1e7).toFixed(2).replace(/\.00$/, '')} Crore`;
  if (n >= 1e5) return `${(n / 1e5).toFixed(2).replace(/\.00$/, '')} Lakh`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1).replace(/\.0$/, '')}K`;
  return String(n);
};
